import { Box, Typography, useTheme, Divider, Stack } from '@mui/material';

const PurchaseDetails = ({
  youngPassengers,
  oldPassengers,
  passengerPrice,
  oldPassengerPrice,
  subtotal,
  discount,
  total,
}) => {
  const totalYoungPassengersPrice = passengerPrice * youngPassengers;
  const totalOldPassengersPrice = oldPassengerPrice * oldPassengers;

  const formatPrice = (value) => {
    return value.toFixed(2).toLocaleString('pt-BR').replace('.', ',');
  };
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: `${theme.palette.primary.dark}`,
        color: `${theme.palette.primary.contrastText}`,
        borderRadius: `${theme.spacingValues.medium}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        padding: `${theme.spacingValues.mediumLarge}`,
        gap: `${theme.spacingValues.medium}`,
      }}
    >
      <Typography variant="h3">Resumo da compra</Typography>
      <Stack direction="column" spacing={1} sx={{ width: '100%' }}>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography
            variant="body2"
            sx={{ color: `${theme.palette.grey[100]}` }}
          >
            {youngPassengers} segurado(s) (0 a 65 anos)
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: `${theme.palette.grey[100]}` }}
          >
            R$ {formatPrice(totalYoungPassengersPrice)}
          </Typography>
        </Stack>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography
            variant="body2"
            sx={{ color: `${theme.palette.grey[100]}` }}
          >
            {oldPassengers} segurado(s) (+65 anos)
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: `${theme.palette.grey[100]}` }}
          >
            R$ {formatPrice(totalOldPassengersPrice)}
          </Typography>
        </Stack>
        <Divider sx={{ borderColor: `${theme.palette.primary.main}` }} />
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography
            variant="body2"
            sx={{ color: `${theme.palette.grey[100]}`, fontWeight: 'bolder' }}
          >
            Subtotal
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: `${theme.palette.grey[100]}`, fontWeight: 'bolder' }}
          >
            R$ {formatPrice(subtotal)}
          </Typography>
        </Stack>
        {discount > 0 && (
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Typography
              variant="body2"
              sx={{ color: `${theme.palette.grey[100]}` }}
            >
              Desconto
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: `${theme.palette.grey[100]}` }}
            >
              - R$ {formatPrice(discount)}
            </Typography>
          </Stack>
        )}
      </Stack>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        sx={{ width: '100%' }}
      >
        <Typography
          variant="body1"
          sx={{
            color: `${theme.palette.primary.contrastText}`,
            fontWeight: 'bolder',
          }}
        >
          Valor total
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: `${theme.palette.primary.contrastText}`,
            fontWeight: 'bolder',
          }}
        >
          R$ {formatPrice(total)}
        </Typography>
      </Stack>
    </Box>
  );
};

export default PurchaseDetails;
